module.exports = __webpack_public_path__ + "img/center_center.a5aea2fb.svg";